export * from "@react-md/core/test-utils/polyfills";
